import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

function LoginButton() {
  const { loginWithRedirect } = useAuth0();

  return (
    <button
      onClick={() => loginWithRedirect()}
      className="btn-primary"
      style={{
        padding: '12px 24px',
        fontSize: '1rem',
        cursor: 'pointer',
      }}
    >
      ログイン
    </button>
  );
}

export default LoginButton;

